import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Called when a user views a credit meter',
  name: 'credit_meter_viewed',
  params: [
    {
      description: 'The location where the credit meter was viewed',
      name: 'location',
      required: true,
      type: 'enum',
      values: ['side_nav', 'canvas', 'dropdown_menu'],
    },
    {
      description: 'How the credit meter was triggered to be viewed (omit if always visible)',
      name: 'trigger',
      required: false,
      type: 'enum',
      values: ['click', 'hover'],
    },
    {
      description: 'Subscription plan name',
      name: 'plan',
      required: true,
      type: 'string',
    },
    {
      description: 'Credit pack quantity currently on the subscription',
      name: 'existing_pack_quantity',
      required: true,
      type: 'number',
    },
    {
      description: 'Whether a credit pack change is already queued on the subscription',
      name: 'credit_pack_change_pending',
      required: true,
      type: 'boolean',
    },
    {
      description: 'Number of credits remaining in the current cycle',
      name: 'credits_remaining',
      required: true,
      type: 'number',
    },
    {
      description: 'Percentage of credits used',
      name: 'pct_used',
      required: true,
      type: 'number',
    },
    {
      description: 'Number of credits used in the current cycle',
      name: 'credits_used',
      required: true,
      type: 'number',
    },
    {
      description: 'Number of days since the billing cycle started',
      name: 'days_since_cycle_start',
      required: true,
      type: 'number',
    },
  ],
};

export default META;
